"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _metadata.getCountryCallingCode;
  }
});
var _metadata = require("./metadata.js");
//# sourceMappingURL=getCountryCallingCode.js.map